import { render, staticRenderFns } from "./OnboardingLoadingOverlay.vue?vue&type=template&id=74fa4791&scoped=true&"
import script from "./OnboardingLoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./OnboardingLoadingOverlay.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingLoadingOverlay.vue?vue&type=style&index=0&id=74fa4791&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa4791",
  null
  
)

export default component.exports